<template>
  <div class="container">
    <div v-if="list.length == 0" class="index-empty">
      <div class="index-empty-box">
        <div class="imageEmptySearch">
          <img src="../../../../assets/images/search.png" alt />
        </div>
      </div>
    </div>
    <div v-if="list.length > 0" style="height: 100%; overflow: auto">
      <!-- <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="height: calc(100% - 0.2vw); overflow: auto"
      > -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="到底啦~"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.id">
          <div class="list">
            <div class="everylist">
              <div class="every">
                <div class="flex">
                  <div class="avatar">
                    <img
                      :src="item.avatarUrl"
                      alt=""
                      style="border-radius: 50%"
                    />
                  </div>
                  <p class="name-list">{{ item.name }}</p>
                </div>

                <div class="flex-row">
                  <p class="refuse" v-if="item.employeeStatus == 5">已拒绝</p>
                  <p class="refuse" v-if="item.employeeStatus == 3">拒绝成功</p>
                  <p class="success" v-if="item.employeeStatus == 4">
                    等待系统审核
                  </p>
                  <p class="success" v-if="item.employeeStatus == 6">
                    担保成功
                  </p>
                  <!-- <p
                    class="refuse"
                    @click="refuse(item.id)"
                    v-if="item.employeeStatus == 2"
                  >
                    拒绝
                  </p>
                  <div class="flex_r" v-if="item.employeeStatus == 2">
                    <button class="look" @click="onLook(item.id)">担保</button>
                  </div> -->
                </div>
              </div>
              <div class="every">
                <div class="flex">
                  <p class="tel">{{ item.phoneNumber }}</p>
                  <p class="list_no">编号:{{ item.account }}</p>
                </div>
                <p class="timer">{{ item.createTime.slice(0, 16) }}</p>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <!-- </van-pull-refresh> -->
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Dialog,
  Grid,
  GridItem,
  Image,
  List,
  PullRefresh,
  Loading,
  Toast,
  Overlay
} from "vant";
import service from "../../../api/invitation/index";
import { mapGetters } from "vuex";
import loading from "../../../components/loading/loading";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Loading.name]: Loading,
    [Toast.name]: Toast,
    [Overlay.name]: Overlay,
    loading
  },
  data() {
    return {
      isLoading: true, //loading状态
      page: 1,
      pageSize: 8,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      firstLoading: true
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.pageSize = 8;
    this.init();
  },
  methods: {
    refuse(id) {
      Dialog.confirm({
        message: "是否拒绝"
      })
        .then(() => {
          service.post({ id: id, statusId: 3 }).then((res) => {
            if (res.statusCode == 200) {
              Toast("拒绝成功");
              this.init();
            } else {
              Toast(res.errors);
            }
          });
        })
        .catch(() => {});
    },
    onLoad() {
      this.page++;
      // if (this.refreshing) {
      //   this.refreshing = false;
      // }
      this.getList().then((list) => {
        this.list = this.list.concat(list.guaranteeLists);
        this.loading = false;
        if (list.total <= this.list.length) {
          this.finished = true;
        }
      });
    },

    // onRefresh() {
    //   this.page = 1;
    //   this.finished = false;
    //   this.loading = true;
    //   this.list = [];
    //   this.isLoading = true;
    //   this.getList().then((list) => {
    //     this.isLoading = false;
    //     if (list.guaranteeLists.length !== 0) {
    //       this.list = list.guaranteeLists;
    //       if (list.total <=  this.list.length) {
    //         this.finished = true;
    //         this.loading = false;
    //       }
    //     } else {
    //       this.list = [];
    //       this.loading = false;
    //     }
    //     this.refreshing = true;
    //     this.onLoad();
    //   });
    // },
    getList() {
      return new Promise((resolve, reject) => {
        service
          .list({
            page: this.page,
            limit: this.pageSize,
            phoneNumber: this.userInfo.phoneNumber
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    init() {
      this.page = 1;
      this.firstLoading = true;
      this.loading = false;
      this.getList().then((list) => {
        this.firstLoading = false;
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        this.finished = false;
        if (list.guaranteeLists.length !== 0) {
          this.list = list.guaranteeLists;
          if (list.total <= this.list.length) {
            this.loading = false;
            this.finished = true;
          }
          // else{
          //   this.onLoad()
          // }
        } else {
          this.list = [];
          this.loading = false;
        }
      });
    },
    onClick(id) {
      this.$router.push({ name: "manager", query: { id: id } });
    },
    onLook(id) {
      Dialog.confirm({
        message: "是否担保"
      })
        .then(() => {
          service.post({ id: id, statusId: 4 }).then((res) => {
            if (res.statusCode == 200) {
              Toast("担保成功");
              this.init();
            } else {
              Toast(res.errors);
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.container {
  // height: calc(100% - 0.2vw);
  font-size: 15px;
  p {
    margin: 1.6vw 0;
  }
  .name-list {
    margin-left: 10px;
  }
  .noOrders {
    width: 100%;
    text-align: center;
    font-size: 15px;
    color: #92909a;
    padding-top: 30vw;
  }
  .everylist {
    border-bottom: 1px solid #e6e6e6;
    margin: 0 0.15rem;
    height: 14.8vw;
    padding: 4vw 0;
  }
  .every {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .list {
    padding: 0 3.7vw;
    background: #fff;
  }
  .flex-row {
    font-size: 14px;
  }
  .look {
    background: linear-gradient(-45deg, #ee0a24, #f96f7f);
    color: #fff;
    height: 31px;
    border-radius: 5px;
    border: 0;
    width: 57px;
    height: 31px;
  }

  .yellow {
    background: linear-gradient(-45deg, #ff7e00, #ffb64e);
    border: 0;
    margin-right: 15px;
    color: #fff;
    height: 31px;
    border-radius: 5px;
    width: 78px;
  }
  .flex_r {
    padding-left: 2vw;
  }
  .tel {
    font-size: 14px;
  }
  .list_no {
    color: #828282;
    margin-left: 2.5vw;
    font-size: 14px;
  }
  .avatar {
    width: 9vw;
    height: 9vw;
  }
  .refuse {
    color: #676767;
  }
  .success {
    color: #ee0a24;
  }
  .timer {
    color: #9f9f9f;
    font-size: 12px;
  }
}
</style>